import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Menubar } from "primereact/menubar";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useAuthHeader, useAuthUser, useSignOut } from "../../auth/AuthService";
import { retrieveStockSession } from "../../Services/StockSessionApiService";

export default function FirmHeader () {
    const {t, i18n} = useTranslation();
    const [cookies, setCookie] = useCookies(['lang']);
    const menu = useRef(null);
    const auth = useAuthUser();
    const authHeader = useAuthHeader();
    const signOut = useSignOut();
    const navigator = useNavigate();

    const logoutFunction = () => {
        if (signOut()) {
            navigator('/login');
        }
    }

    const items = [
        {
            template: <Link to="/screen1" className="no-underline flex w-full justify-content-center px-2"><Button label={t("Screen Type 1")} text className='lg:text-white px-1 py-0 w-6 lg:w-full text-sm font-light' /></Link>,
            className: 'justify-content-center'
        },
        {
            template: <Link to="/screen2" className="no-underline flex w-full justify-content-center px-2"><Button label={t("Screen Type 2")} text className='lg:text-white px-1 py-0 w-6 lg:w-full text-sm font-light' /></Link>,
            className: 'justify-content-center'
        },
        {
            template: <Link to="/screen3" className="no-underline flex w-full justify-content-center px-2"><Button label={t("Screen Type 3")} text className='lg:text-white px-1 py-0 w-6 lg:w-full text-sm font-light' /></Link>,
            className: 'justify-content-center'
        },
        {
            template: <Link to="/setting" className="no-underline flex w-full justify-content-center px-2"><Button label={t("Favorite Setting")} text className='lg:text-white px-1 py-0 w-6 lg:w-full text-sm font-light' /></Link>,
            className: 'justify-content-center'
        }
    ];
    const itemsIssuer = [
        {
            template: <Link to="/screen1_issuer" className="no-underline flex w-full justify-content-center px-2"><Button label={t("Screen Type 1")} text className='lg:text-white px-1 py-0 w-6 lg:w-full text-sm font-light' /></Link>,
            className: 'justify-content-center'
        },
        {
            template: <Link to="/screen2" className="no-underline flex w-full justify-content-center px-2"><Button label={t("Screen Type 2")} text className='lg:text-white px-1 py-0 w-6 lg:w-full text-sm font-light' /></Link>,
            className: 'justify-content-center'
        },
        {
            template: <Link to="/screen3" className="no-underline flex w-full justify-content-center px-2"><Button label={t("Screen Type 3")} text className='lg:text-white px-1 py-0 w-6 lg:w-full text-sm font-light' /></Link>,
            className: 'justify-content-center'
        },
        {
            template: <Link to="/setting" className="no-underline flex w-full justify-content-center px-2"><Button label={t("Favorite Setting")} text className='lg:text-white px-1 py-0 w-6 lg:w-full text-sm font-light' /></Link>,
            className: 'justify-content-center'
        }
    ];

    let topMenu = auth()?.role == 'issuer' ? itemsIssuer : items;
  
    let itemUser = [
        { 
            label: <span className="text-sm">Preference</span>, 
            icon: 'pi pi-wrench',
            command: () => {
                navigator('/firm/user/edit')
            }
        },
        { 
            label: <span className="text-sm">Data and information usage policy</span>, 
            icon: 'pi pi-info-circle',
            command: () => {
                navigator('/firm/disclaimer')
            } 
        },
        { separator: true},
        { 
            label: <span className="text-sm">Logout</span>, 
            icon: 'pi pi-sign-out',
            command: () => {
                logoutFunction()
            }
        },
    ];

    async function checkStockSession() {
        await retrieveStockSession(authHeader())
        .catch((error) => {
            if (error?.response?.status === 403) {
                logoutFunction();
            }
        })
    }

    useEffect(()=> {
        i18n.changeLanguage(cookies.lang ?? 'en');
        const interval = setInterval(checkStockSession, 10000);

        return () => {
            clearInterval(interval);
        }
    }, [cookies.lang])

    return (
        <>
            <div className='absolute top-0 w-full z-5 firm-menu-header-container hidden-print'>
                <div className='firm-menu-header bg-header shadow-3 w-full flex justify-content-center border-bottom-1'>
                    <div className='flex w-11  align-items-center justify-content-center'>
                        <div className='flex-1'>
                            <Menubar 
                                className="border-none py-0"
                                style={{color: 'white'}}
                                model={topMenu} 
                                orientation="horizontal" 
                                start={<div className="flex text-white text-900 text-3xl font-bold mr-1">ICSX</div>} 
                                end={
                                <div className='flex gap-1 align-items-center justify-content-end'>
                                    <Button className="bg-screen ml-2 my-2 text-white"  onClick={(e) => menu.current.toggle(e)}>
                                        <i className="pi pi-user pr-2"></i>
                                        <span>{auth()?.userData?.username}</span>
                                    </Button>
                                    <Menu model={itemUser} popup ref={menu}/>
                                </div>} 
                                breakpoint="720px" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}